<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title> {{ $t("translationPriceList") }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon class="float-left" small v-on="on">
            <v-icon color="green" style="font-size: 22px" @click="exchangeDialog = true">
              mdi-percent-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("exchangePriceLang") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon color="blue" style="font-size: 22px"> mdi-refresh </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("refresh") }}(f5)</span>
      </v-tooltip>
      <log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="openUploadDialog">
            <v-icon color="deep-orange" style="font-size: 22px">
              mdi-database-import-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("importData") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f6']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="goTo('translationPrice')"
            v-on="on"
            @click="goTo('translationPrice')"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("translationPrice") }}</span>
      </v-tooltip>
      <v-tooltip v-if="selected.length > 0" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon color="pink" style="font-size: 22px"> mdi-trash-can-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("remove") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon color="blue" style="font-size: 22px">
              {{
                showSelect ? "mdi-checkbox-blank-outline" : "mdi-checkbox-marked-outline"
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("select-row") }}</span>
      </v-tooltip>
      <export-excel
        :data="totals.excel"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" icon small v-on="on">
              <v-icon style="font-size: 22px" color="green">
                mdi-file-excel-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("excel") }}</span>
        </v-tooltip>
      </export-excel>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon class="float-left" small v-on="on">
            <v-icon color="primary" style="font-size: 22px" @click="filter = true">
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("filter") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon class="float-left" small v-on="on">
            <v-icon color="primary" style="font-size: 22px" @click="printDialog = true">
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("print") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mb-2">
      <v-col class="px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          flat
          clearable
          height="30"
          :background-color="$vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5'"
          dense
        />
      </v-col>
    </v-row>
    <v-col cols="12" class="px-2 pt-0">
      <v-data-table
        v-if="headers"
        :height="tableHeight"
        fixed-header
        v-model="selected"
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/translation/price/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item link @click="openDeleteDialog(item)">
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat(item.fee) }}
        </template>
        <template v-slot:item.special_translation="{ item }">
          {{ $numberFormat(item.special_translation) }}
        </template>
        <template v-slot:item.judicial_approval="{ item }">
          {{ $numberFormat(item.judicial_approval) }}
        </template>
        <template v-slot:item.equal_original="{ item }">
          {{ $numberFormat(item.equal_original) }}
        </template>
        <template v-slot:item.judicial_approval="{ item }">
          {{ $numberFormat(item.judicial_approval) }}
        </template>
        <template v-slot:item.office_services="{ item }">
          {{ $numberFormat(item.office_services) }}
        </template>
        <template v-slot:item.stamp_translator="{ item }">
          {{ $numberFormat(item.stamp_translator) }}
        </template>
        <template v-slot:item.verification_services="{ item }">
          {{ $numberFormat(item.verification_services) }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="translationPrice"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="exchangeDialog"
      width="700"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="exchangeDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <price-exchange @close="exchangeDialog = false" />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <aicomplete
              v-model="documentType"
              title="documentType"
              type="setConfig"
              :new-btn="true"
              :rules="[(v) => !!v || $t('is-required')]"
              :data="JSON.stringify({ key: 't_docuemtnType', type: 'translation' })"
              :val="documentType"
            />
          </v-col>
          <v-col cols="12" md="4">
            <aicomplete
              v-model="fromLanguage"
              title="fromLanguage"
              type="setConfig"
              :rules="[(v) => !!v || $t('is-required')]"
              :new-btn="true"
              :data="JSON.stringify({ key: 't_languages', type: 'translation' })"
              :val="fromLanguage"
            />
          </v-col>
          <v-col cols="12" md="4">
            <aicomplete
              v-model="toLanguage"
              title="toLanguage"
              type="setConfig"
              :new-btn="true"
              :rules="[(v) => !!v || $t('is-required')]"
              :data="JSON.stringify({ key: 't_languages', type: 'translation' })"
              :val="toLanguage"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import aicomplete from "../../components/general/AIcomplete/index";
import Upload from "../../components/general/upload/upload";
import PriceExchange from "./partial/priceExchange";
export default {
  name: "TranslationList",
  components: {
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    aicomplete,
    Print,
    Upload,
    PriceExchange,
    Task,
  },
  mixins: [General],
  props: ["input", "refId"],
  data: () => ({
    selected: [],
    invoicePrintDialog: false,
    exchangeDialog: false,
    uploadDialog: false,
    printDialog: false,
    deletDialog: false,
    documentType: null,
    toLanguage: null,
    fromLanguage: null,
    dialogData: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    printId: null,
    showSelect: false,
    filter: false,
    productStatus: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    excelItems: [],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell") {
          if (s.value === "pre_invoice") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      var app = this;
      app.excelItems = [];
      const totals = this.items.reduce(
        (acc, d) => {
          acc.excel.push({
            // type: app.$t(d.type),
            document_type: d.documentType.name,
            from_language: d.fromLanguage.name,
            to_language: d.toLanguage.name,
            fee: app.$numberFormat(d.fee),
            stamp_translator: app.$numberFormat(d.stamp_translator),
            foreign_approval: app.$numberFormat(d.foreign_approval),
            judicial_approval: app.$numberFormat(d.judicial_approval),
            office_services: app.$numberFormat(d.office_services),
            verification_services: app.$numberFormat(d.verification_services),
            special_translation: app.$numberFormat(d.special_translation),
            user: d.user ? d.user.name : "",
          });
          return acc;
        },
        {
          excel: [],
          discount: 0,
          tax: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    this.getItems();
  },
  beforeMount() {
    this.type = "translation";
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("documentType"),
        sortable: false,
        value: "documentType.name",
        width: 150,
      },
      {
        text: this.$t("fromLanguage"),
        sortable: false,
        value: "fromLanguage.name",
      },
      {
        text: this.$t("toLanguage"),
        sortable: false,
        value: "toLanguage.name",
      },
      {
        text: this.$t("baseTranslate"),
        sortable: false,
        value: "fee",
      },
      {
        text: this.$t("specialTranslat"),
        sortable: false,
        value: "special_translation",
      },
      {
        text: this.$t("foreignApproval"),
        sortable: false,
        value: "judicial_approval",
      },
      {
        text: this.$t("judicialApproval"),
        sortable: false,
        value: "judicial_approval",
      },
      {
        text: this.$t("officeServices"),
        sortable: false,
        value: "office_services",
      },
      {
        text: this.$t("stampTranslator"),
        sortable: false,
        value: "stamp_translator",
      },
      {
        text: this.$t("equalOriginal"),
        sortable: false,
        value: "equal_original",
      },
      {
        text: this.$t("verificationServices"),
        sortable: false,
        value: "verification_services",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
  },
  mounted() {
    // this.getItems()
  },
  methods: {
    openUploadDialog(item) {
      this.uploadDialog = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "translationPriceEdit", params: { id: item.uid } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "translationPrice", {
          params: {
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            documentType: app.documentType ? app.documentType.id : null,
            fromLanguage: app.fromLanguage ? app.fromLanguage.id : null,
            toLanguage: app.toLanguage ? app.toLanguage.id : null,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "translationPrice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      const delete_items = app.selected.map((item) => item.id);
      app.$axios
        .get(this.$endpoint + "translationPrice", {
          params: {
            deleteItems: delete_items,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped></style>
